import { Box } from '@doltech/ui/lib/figma/Common/BoxV2';
import { Typography } from '@doltech/ui/lib/figma/DesignSystemV2/Typography';
import { dolDinhLucAuthor } from '@doltech/ui/lib/figma/Blog/dolDinhLucAuthor.data';
import * as React from 'react';
import { components } from '@doltech/pageManagement/dto';
import styled from 'styled-components';
import { AuthorInfoPdf } from '@doltech/ui/lib/figma/Layout/Landing/Header/AuthorInfo';
import renderNode, { Div } from '@doltech/ui/lib/figma/renderNode';
import { ActionLinksPdf } from './ActionLinksPdf';
import { PdfPage } from '@doltech/ui/lib/figma/Layout/Landing/Content/PageBreakPdf';
import { fixSafariDate } from '@doltech/utils/lib/date';

interface ViewSubjectHeaderPdfProps {
  seoData: components['schemas']['PageResponseDTOObject'];
  children?: React.FC | JSX.Element | JSX.Element[];
}

const CONTENT_PDF_WIDTH = 848;
const IMAGE_RATIO = 3 / 2;
const MAX_HEIGHT_BY_RATIO = CONTENT_PDF_WIDTH / IMAGE_RATIO;
const MAX_HEIGHT_IMAGE = 400;

const Img = styled.img.withConfig({
  componentId: 'ViewSubjectHeaderPdf_Img',
} as any)`
  max-width: 100%;
  height: ${Math.min(MAX_HEIGHT_BY_RATIO, MAX_HEIGHT_IMAGE)}px;
`;

const Main = styled.div`
  width: ${CONTENT_PDF_WIDTH}px;
  padding: 0 22px;
  .text-container {
    margin-bottom: 16px;
  }
  .img-cover {
    text-align: center;
  }
`;

export const ViewSubjectHeaderPdf = (props: ViewSubjectHeaderPdfProps) => {
  const { seoData, children } = props;
  const { description, fileInfo, title } = seoData.dol;
  return (
    <Main className="header-seo-bg">
      <div className="header-seo-content">
        <div className="header-row seo-test-header">
          <div className="info-container">
            <div className="text-container">
              <Box mb={['8px', '16px']} className="title">
                <Typography.Text variant="bold/32" className="title-text">
                  {title}
                </Typography.Text>
              </Box>
              <Box className="desc">
                <Typography.Text className="desc-text" variant="regular/20-32" color="black70">
                  {description}
                </Typography.Text>
              </Box>
            </div>
            <AuthorInfoPdf
              pageId={seoData.id}
              author={dolDinhLucAuthor}
              publishedDate={fixSafariDate(seoData.lastModifiedAt)}
            />
            <Box mb={['16px', '32px']} className="extra-container">
              {renderNode(Div, children, props)}
            </Box>
            <Box mb="24px" className="img-cover" bg="gray20">
              <Img src={fileInfo?.url} alt={title} />
            </Box>
          </div>
        </div>
      </div>
    </Main>
  );
};

export const ViewSubjectHeaderWithTestAction = (props) => (
  <PdfPage>
    <ViewSubjectHeaderPdf {...props}>
      <ActionLinksPdf {...props} />
    </ViewSubjectHeaderPdf>
  </PdfPage>
);
